import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
//import { useNavigate } from 'react-router-dom';
import { loginFailure, setMenu } from '../../actions/index';
import './SideBarMenu.css';

const SideBarMenu = () => {
  const [openSection, setOpenSection] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  //const Navigate = useNavigate();

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? '' : section);
    //if (section === 'empresa') {
    //  Navigate('/empresa');
    //} else if (section === 'usuario') {
    //  Navigate('/usuario');
    //} else if (section === 'produccion') {
    //  Navigate('/produccion');
    //} else if (section === 'calidad') {
    //  Navigate('/calidad');
    //} else {
    //  Navigate('/');
    //}
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleSubMenu = (submenu) => {
    setIsMenuOpen(!isMenuOpen);
    dispatch(setMenu(submenu)); // Despacha la acción para seleccionar el submenú
  };

  const handleLogout = () => {
    dispatch(loginFailure('User logged out'));
  };

  return (
    <div>
      <button className={`hamburger-button ${isMenuOpen ? 'menu-open' : 'menu-closed'}`} onClick={toggleMenu}>
        {isMenuOpen ? '×' : '☰'}
      </button>
      <div className={`sidebar-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="menu-section">
          <div className="menu-title" onClick={() => toggleSection('empresa')}>
            <div>Empresas</div>
            <div>{openSection === 'empresa' ? '▲' : '▼'}</div>
          </div>
          {openSection === 'empresa' && (
            <div className="submenu">
              <div className="submenu-item" onClick={() => toggleSubMenu('empresaNue')}>Crear nueva empresa</div>
              <div className="submenu-item" onClick={() => toggleSubMenu('empresaAct')}>Empresas</div>
            </div>
          )}
        </div>
        <div className="menu-section">
          <div className="menu-title" onClick={() => toggleSection('usuario')}>
            <div>Usuarios</div>
            <div>{openSection === 'usuario' ? '▲' : '▼'}</div>
          </div>
          {openSection === 'usuario' && (
            <div className="submenu">
              <div className="submenu-item" onClick={() => toggleSubMenu('usuarioNue')}>Crear nuevo usuario</div>
              <div className="submenu-item" onClick={() => toggleSubMenu('usuarioAct')}>Usuarios</div>
            </div>
          )}
        </div>
        <div className="menu-section">
          <div className="menu-title" onClick={handleLogout}>
            <div>Cerrar sesión</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBarMenu;
